var store = {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async setupEventListeners(store) {
			console.log('setting up runtime events ---');
			browser.runtime.onMessage.addListener((request, sender, sendResponse) => {
				let type = request.type || '';
				if (type === 'settings:updated') {
					store.dispatch(
						'settings/update',
						{ sender, request },
						{ root: true }
					);
				}
				if (type === 'user:login') {
					store.dispatch('user/init', null, { root: true }).then(isLoggedIn => {
						if (isLoggedIn) {
							store.dispatch('afterLogin');
						}
					});
				}
				if (type === 'user:logout') {
					store.dispatch('note/reset');
					store.dispatch('bucket/reset');
					store.dispatch('user/logout');
				}
				if (type === 'user:updated') {
					store.dispatch('user/updateUser');
				}

				if (type === 'error:network') {
					store.dispatch('message/onConnectionWarning');
				}

				if (type === 'blocks:updated') {
					store.dispatch('block/refresh', {}, { root: true });
				}

				// if (type === 'action:dashboard:open') {
				// 	store.dispatch('ui/openDashboard');
				// }

				return true;
			});
		},
		async signal(store, eventName) {
			if (window.mode === 'EXTENSION') {
				browser.runtime.sendMessage({ type: eventName });
			}
		},
		disconnect: function(store) {}
	}
};

export default store;
